import { Route, Routes } from "@angular/router";

import { localReservationMatcher } from "./local-reservation.matcher";

import { WARM_OFFLINE } from "src/app/core/offline/route-warm.service";

/**
 * Exported individually, and that is not decoration: `reservations.routes.ts` mounts two of these
 * under `/admin/reservations` and used to pick them out of the array **by index**. Inserting the
 * pending route below shifted that array and silently unregistered `view/:reservationNumber`, so
 * every confirmed reservation 404ed. Names cannot shift.
 */
export const myTicketsListRoute: Route = {
  path: "",
  title: (route, state) => {
    return state.url.includes("admin") ? "TICKETS.RESERVATIONS" : "TICKETS.MY_RESERVATIONS";
  },
  loadComponent: () => import("./pages/my-tickets/my-tickets.component").then((c) => c.MyTicketsComponent),
};

/**
 * A booking that has been queued but not yet accepted by any server (T-18).
 *
 * Must be registered **before** `reservationDetailsRoute`: they share a segment, and Angular takes
 * the first match, so `:reservationNumber` would otherwise swallow `local-…` and hand it to
 * `TicketComponent` — which would ask the server for an id it has never issued.
 */
export const localReservationRoute: Route = {
  matcher: localReservationMatcher,
  // Warmed with the booking flow: this is where a queued booking navigates, so a cold chunk here
  // strands the clerk at the worst possible moment — the sale is already on disk by then.
  data: { [WARM_OFFLINE]: true },
  loadComponent: () => import("./pages/pending-ticket/pending-ticket.component").then((c) => c.PendingTicketComponent),
};

/** A confirmed reservation, by its server id. */
export const reservationDetailsRoute: Route = {
  path: ":reservationNumber",
  loadComponent: () => import("src/app/shared/components/ticket/ticket.component").then((c) => c.TicketComponent),
};

export const myTicketsRoutes: Routes = [myTicketsListRoute, localReservationRoute, reservationDetailsRoute];
